import {createSlice, createSelector} from "@reduxjs/toolkit";
import {STATUS, SideBarType, CASINO_CATEGORY_TYPE} from './../common/Foundation';
import _ from 'lodash';
import { category } from "../components/CasinoComponent/constants";
import {CASINO_CATEGORY_MAP} from "../components/LandingPageComponent/CommonComponent/CommonUtils";

const {NORMAL, NEW} = CASINO_CATEGORY_TYPE;

const listOfSubCategoryForNew = [];
const defaultLimitSearchingChars = 80;
const defaultLoadMoreItems = 25;

const defaultNewCategory = {
	id: -1,
	categoryName: 'New',
	isDefault: true,
	orderBy: 2,
};

const defaultCategory = {
	'0': {
		mainCategory: {
			id: 0,
			categoryName: 'All Games',
			isDefault: true,
			orderBy: 0,
		},
		subCategory: null
	}
};

const allGameNotDefault = {
	'0': {
		mainCategory: {
			id: 0,
			categoryName: 'All Games',
			orderBy: 0,
		},
		subCategory: null
	}
};

export const defaultSubCategory = {
	id: 0,
	categoryName: 'All',
	isDefault: true,
	orderBy: 0,
};
export const defaultSubFavoriteCategory = {
	id: -1,
	categoryName: 'All Favorites',
	isDefault: true,
	orderBy: 0,
};
const defaultFavoriteCategory = {
	'0': {
		mainCategory: {},
		subCategory: defaultSubFavoriteCategory
	}
};

export const defaultProviders = [
	{providerId: -2, providerName: "All Provider"}
];

const updateCasinoFilter = (state, key, value) => {
	const tmp = state.casinoFilter;
	tmp[key] = value;
	state.casinoFilter = tmp;
}

const checkIsNewGame = state => {
	const mainCategoryType = _.get(state.selectedCategory, 'mainCategory.categoryType', NORMAL);
	const subCategoryType = _.get(state.selectedCategory, 'subCategory.categoryType', NORMAL);
	const isNewGame = mainCategoryType === NEW || subCategoryType === NEW ? true : '';
	updateCasinoFilter(state, 'isNewGame', isNewGame);
}
const updateNewCategoryProcess = (state) => {
	_.forEach(state.categories, (cat, key) => {
		const mainCategory = cat['mainCategory'];
		const subCategory = cat['subCategory'];

		if (_.includes(listOfSubCategoryForNew, mainCategory.categoryName) && !_.isEmpty(subCategory)) {
			cat['subCategory'] = subCategory.addAll(defaultNewCategory);
		}
	});
}

const updateCategoryProcess = (state, currentCategory) => {
	const mainCategory = currentCategory['mainCategory'];
	let subCategories = !_.isEmpty(currentCategory['subCategory']) ? _.concat([defaultSubCategory], currentCategory['subCategory']) : [];

	if (_.includes(listOfSubCategoryForNew, mainCategory.categoryName) && !_.isEmpty(subCategories)) {
		subCategories = _.concat(subCategories, defaultNewCategory);
	}

	const subCategory = _.get(subCategories, '[0]', {});
	const tmp = state.selectedCategory;
	tmp['mainCategory'] = mainCategory;
	tmp['subCategory'] = subCategory;

	state.selectedCategory = tmp;

	let categoryId = '';
	const mainCategoryId = mainCategory.id;
	if (_.isEmpty(currentCategory['subCategory'])) {
		categoryId = (mainCategoryId === -1 || mainCategoryId === 0) ? '' : mainCategoryId;
	} else {
		const subCategoryId = _.get(subCategory, 'id', 0);
		if (subCategoryId !== 0) {
			categoryId = subCategoryId;
		} else if (mainCategoryId !== 0) {
			categoryId = mainCategoryId;
		}
	}

	const {categoryType} = mainCategory;

	if (categoryType === NEW) {
		updateCasinoFilter(state, 'categoryId', '');
		updateCasinoFilter(state, 'isNewGame', true);
	} else {
		updateCasinoFilter(state, 'categoryId', categoryId);
	}
}

const resetCasinoFilter = (state) => {
	state.isLoadMoreGames = false;
	checkIsNewGame(state);
	updateCasinoFilter(state, 'beginIndex', 0);
	state.numberOfRecordsPerPage = defaultLoadMoreItems;
	state.casinoFilter['moreItems'] = defaultLoadMoreItems;
}

const options = {
	name: 'CasinoSlice',
	initialState: {
		isSearchingGames: false,
		isFetchingGames: false,
		isLoadMoreGames: false,
		isServerError: false,
		casinoSlider: [],
		categories: {},
		selectedCategory: {},
		casinoGames: [],
		wallets: [],
		limitSearchingChars: defaultLimitSearchingChars,
		numberOfRecordsPerPage: defaultLoadMoreItems,
		loadMoreItems: 28,
		casinoFilter: {
			categoryId: '',
			channelId: 'Desktop',
			gameName: '',
			providerName: '',
			provider: '',
			providerList: [],
			status: STATUS.ACTIVE,
			beginIndex: 0,
			moreItems: defaultLoadMoreItems,
			isNewGame: "",
			orderBy: 'gameName,provider'
		},
		gameflexExpressLibrary: {},
		jackpotList: [],
		casinoProviders: [],
		otherCasinoProviders: [],
		listCasinoSideBar: [],
		isShowCasinoGameWindow: false,
		isLoadingGame: false,
		isCasinoFavouriteClicked: false,
		gameWindowParamaters: {},
		isLiveCasino: false,
		casinoCategoryLandingSelected: ''
	},
	reducers: {
		updateWallets: (state, {payload}) => {
			state.wallets = payload;
		},
		resetFavoritesCategory: state => {
			state.selectedCategory = defaultFavoriteCategory[0];
		},
		updateGameflexExpressLibrary: (state, {payload}) => {
			state.gameflexExpressLibrary = payload;
		},
		updateJackpotList: (state, {payload}) => {
			state.jackpotList = payload;
		},
		updateJackpots: (state, {payload}) => {
			_.forEach(state.jackpotList, (value, key) => {
				if (value.IncrementInterval == payload) {
					value.Amount += value.IncrementValue;
				}
			});
		},
		updateGameWindowParamaters: (state, {payload}) => {
			state.gameWindowParamaters = payload;
		},
		setCasinoFavouriteClicked: (state, {payload}) => {
			state.isCasinoFavouriteClicked = payload;
		},
		setLiveCasino: (state, {payload}) => {
			state.isLiveCasino = payload;
		},
		updateCasinoGameWindow: (state, {payload}) => {
			state.isShowCasinoGameWindow = payload;
		},
		updateLoadingGame: (state, {payload}) => {
			state.isLoadingGame = payload;
		},
		updateIsSearchingGames: (state, {payload}) => {
			state.isSearchingGames = payload;
		},
		checkServerError: (state, {payload}) => {
			state.isServerError = payload;
		},
		updateIsFetchingGames: (state, {payload}) => {
			state.isFetchingGames = payload;
		},
		updateMoreItemsFilter: (state, {payload}) => {
			state.isLoadMoreGames = true;
			const moreItems = payload > 0 ? payload : state.loadMoreItems;

			const tmp = {...state.casinoFilter};
			tmp['beginIndex'] = tmp['beginIndex'] + tmp['moreItems'];

			if (moreItems !== tmp['moreItems']) {
				tmp['moreItems'] = moreItems;
			}
			state.numberOfRecordsPerPage += moreItems;
			state.casinoFilter = tmp;
		},
		resetCasinoFilter: (state, {payload}) => {
			resetCasinoFilter(state);
		},

		updateCasinoSlider: (state, {payload}) => {
			state.casinoSlider = payload;
		},
		updateCasinoProviders: (state, {payload}) => {
			state.casinoProviders = [...defaultProviders, ...payload];
		},
		updateOtherCasinoProviders: (state, {payload}) => {
			state.otherCasinoProviders = payload;
		},
		updatelistCasinoSideBar: (state, {payload}) => {
			state.listCasinoSideBar = payload;
		},
		updateCategory: (state, {payload}) => {
			let selectedIndex = -1;
			if (!_.isEmpty(state.casinoCategoryLandingSelected)) {
				let categorySelected = state.casinoCategoryLandingSelected.toLocaleLowerCase();
				if (categorySelected === CASINO_CATEGORY_MAP.JACKPOTS.name.toLowerCase()) {
					categorySelected = CASINO_CATEGORY_MAP.SLOTS.name.toLowerCase();
				}
				selectedIndex = Object.keys(payload).find(key => {
					return payload[key] && payload[key].mainCategory && payload[key].mainCategory.categoryName &&
						payload[key].mainCategory.categoryName.trim().toLocaleLowerCase() === categorySelected;
				});
			}
			if (payload[selectedIndex]) {
				payload[selectedIndex].mainCategory.isDefault = true
				state.categories = _.merge(allGameNotDefault, payload);
				state.categories = _.merge(defaultCategory, payload);
				updateNewCategoryProcess(state);
				updateCategoryProcess(state, payload[selectedIndex]);

				// Ticket PINB-31479 - Jackpot banner route to Slots --> Jackpot Slots -- BEGIN --
				let selectedSub = null;
				if (!_.isEmpty(state.casinoCategoryLandingSelected) &&
					state.casinoCategoryLandingSelected.toLocaleLowerCase() === CASINO_CATEGORY_MAP.JACKPOTS.name.toLowerCase()) {
					let subs = payload[selectedIndex].subCategory;
					if (subs && subs.length > 0) {
						selectedSub = _.filter(subs, sub => {
							return sub.categoryName.toLocaleLowerCase() === CASINO_CATEGORY_MAP.JACKPOTS.defaultCategory.toLowerCase();
						})[0];
					}
				}
				if (selectedSub) {
					const tmp = state.selectedCategory;
					tmp['subCategory'] = selectedSub;
					state.selectedCategory = tmp;
					updateCasinoFilter(state, 'categoryId', selectedSub.id);
				}
				// Ticket PINB-31479 - Jackpot banner route to Slots --> Jackpot Slots -- END --

				state.casinoCategoryLandingSelected = '';
			} else {
				state.categories = _.merge(defaultCategory, payload);
				updateNewCategoryProcess(state);
				updateCategoryProcess(state, defaultCategory[0]);
			}
		},
		selectMainCategory: (state, {payload}) => {
			const currentCategory = state.categories[payload.id] || {};
			resetCasinoFilter(state);
			updateCategoryProcess(state, currentCategory);
		},
		selectSubCategory: (state, {payload}) => {
			resetCasinoFilter(state);
			const tmp = state.selectedCategory;
			tmp['subCategory'] = payload;
			state.selectedCategory = tmp;
			const subCategoryId = _.get(state.selectedCategory, 'subCategory.id', 0);
			const mainCategoryId = _.get(state.selectedCategory, 'mainCategory.id', 0);
			let categoryId = '';
			if (subCategoryId === -1) {
				categoryId = mainCategoryId;
				updateCasinoFilter(state, 'isNewGame', true);
			} else if (subCategoryId !== 0) {
				categoryId = subCategoryId;
			} else if (subCategoryId === 0 && mainCategoryId !== 0) {
				categoryId = mainCategoryId;
				updateCasinoFilter(state, 'isNewGame', '');
			}

			updateCasinoFilter(state, 'categoryId', categoryId);
		},
		updateCasinoProviderFilter: (state, {payload}) => {
			updateCasinoFilter(state, 'providerList', payload);
		},
		updateCasinoFilter: (state, {payload}) => {
			const {key, value} = payload;
			updateCasinoFilter(state, key, value);
		},
		clearCasinoGames: (state) => {
			state.casinoGames = [];
		},
		updateCasinoGames: (state, {payload}) => {
			if (!_.isEmpty(payload)) {
				if (state.casinoFilter.moreItems < payload.length) {
					state.casinoFilter.moreItems = payload.length;
				}
				if (!state.isLoadMoreGames) {
					state.casinoGames = payload;
				} else {
					const tmp = state.casinoGames;
					state.casinoGames = _.concat(tmp, payload);
				}
			}
		},
		updateCasinoCategoryLandingSelected: (state, {payload}) => {
			state.casinoCategoryLandingSelected = payload;
		}
	}
}

export const CasinoSlice = createSlice(options);

export const getLimitSearchingCharsSelector = state => state.CasinoSlice.limitSearchingChars;
export const getSelectedMainCategoryIdSelector = state => _.get(state.CasinoSlice.selectedCategory, 'mainCategory.id');
export const getSelectedSubCategoryIdSelector = state => _.get(state.CasinoSlice.selectedCategory, 'subCategory.id', 0);
export const getSelectedProviderSelector = state => _.map(state.CasinoSlice.casinoFilter.providerList, provider => provider.providerId);
export const getCasinoSliderFilterSelector = state => state.CasinoSlice.casinoSliderFilter;
export const getHotCasinoGameSelector = createSelector(
	state => _.find(state.CasinoSlice.listCasinoSideBar, sidebar => sidebar.id === SideBarType.HOT_CASINO_GAME),
	hotCasinoGameSidebar => _.get(hotCasinoGameSidebar, 'hotCasinoGames.casino', [])
);
export const getHotLiveCasinoGameSelector = createSelector(
	state => _.find(state.CasinoSlice.listCasinoSideBar, sidebar => sidebar.id === SideBarType.HOT_CASINO_GAME),
	hotCasinoGameSidebar => _.get(hotCasinoGameSidebar, 'hotCasinoGames.liveCasino', [])
);

export const {
	updateCasinoCategoryLandingSelected,
} = CasinoSlice.actions

export default CasinoSlice.reducer;



// WEBPACK FOOTER //
// ./src/app/slices/CasinoSlice.js